import { createUseStyles } from 'react-jss';

const styles = {
  effectiveDateSelect: {
    margin: '4rem auto 8rem',
  },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
